import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const sleepSteps = [
  {
    number: 1,
    title: 'Settle into Comfort',
    description: 'Lie down in your favorite sleeping position. Adjust pillows and covers for maximum comfort and support.'
  },
  {
    number: 2,
    title: 'Gentle Breathing',
    description: 'Take slow, deep breaths. Feel your belly rise and fall with each inhalation and exhalation.'
  },
  {
    number: 3,
    title: 'Progressive Relaxation',
    description: 'Starting from your toes, consciously relax each part of your body. Let go of any remaining tension.'
  },
  {
    number: 4,
    title: 'Surrender to Sleep',
    description: 'Allow the calming words to guide you deeper into relaxation. Let sleep come naturally and peacefully.'
  }
];

const SleepingMeditationSession2: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Sleeping Meditation Session 2',
      description: 'Completed Sleeping Meditation Session 2.',
      image: require('../assets/sleeping.png').default || require('../assets/sleeping.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/sleeping-meditation');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 2: Sleep Meditation</h1>
              <p className="session-description">
                Experience deep, restorative sleep with this soothing guided meditation. Let stress melt away as you prepare for a peaceful night's rest.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/lu_cLaBTXio"
                  title="Session 2: Sleep Meditation"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Meditate for Sleep</h2>
                <div className="session-steps">
                  {sleepSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default SleepingMeditationSession2;

